import { Commit } from 'vuex'

import aiAssistantService from '@/services/ai-assistant.service'

import { AIAssistantActionTypes } from './action_types'
import { AIAssistantMutationTypes } from './mutation_types'

export const actions = {
  async [AIAssistantActionTypes.GET_CONVERSATIONS] (
    { commit }: { commit: Commit },
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_CONVERSATIONS_PENDING, true)
      const response = await aiAssistantService.getConversations()
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_CONVERSATIONS_PENDING, false)
    }
  },
  async [AIAssistantActionTypes.GET_CONVERSATION_MESSAGES] (
    { commit }: { commit: Commit },
    conversationId: string,
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_CONVERSATION_MESSAGES_PENDING, true)
      const response = await aiAssistantService.getConversationMessages(conversationId)
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_CONVERSATION_MESSAGES_PENDING, false)
    }
  },
  async [AIAssistantActionTypes.POST_PROMPT] (
    { commit }: { commit: Commit },
    { mnemo, prompt, conversationId = null }: { mnemo: string, prompt: string, conversationId?: string | null },
  ) {
    try {
      commit(AIAssistantMutationTypes.SET_POST_PROMPT_PENDING, true)
      const response = await aiAssistantService.postPrompt(mnemo, prompt, conversationId)
      return response.data
    } finally {
      commit(AIAssistantMutationTypes.SET_POST_PROMPT_PENDING, false)
    }
  },
}